import React from 'react';
import { useSelector } from 'react-redux';
import StepsContent from '../../components/stepsContent';
import ActionBar from '../../components/actionBar';
import ProgressBar from '../../components/progressBar';
import steps from '../../survey/steps';
import MenuButton from '../../components/menuButton';
import questions from '../../survey/questions';
import questionsMan from '../../surveyMan/questionsMan';
import classNames from 'classnames';
import s from './index.module.scss';
import { stepsComponents } from '../../survey/stepsComponents';
import { stepsComponentsMan } from '../../surveyMan/stepsComponentsMan';

function HeaderButton({ showMenuButton, planMan }) {
	function goBack() {
		steps.navigate.back();
		steps.userMovedToPreviousStepByClick();
	}

	if (showMenuButton) {
		return (
			<div className={s.menuButtonWrapper}>
				<MenuButton planMan={planMan} />
			</div>
		);
	}

	return (
		<button data-prevent-from-blur onClick={goBack} type="button" className={s.goBackButton}>
			<div data-prevent-from-blur className={s.goBackButtonContent} />
		</button>
	);
}

function Steps() {
	let showActionBar = useSelector((state) => state.steps.showActionBar);
	let showStatusBar = useSelector((state) => state.steps.showStatusBar);
	const currentStepCompleted = useSelector((state) => state.steps.currentStepCompleted);
	const totalSteps = useSelector((state) => state.steps.totalSteps);
	const showMenuButton = useSelector((state) => state.steps.currentStepIndex) === 0;
	const menuOpenedClass = useSelector((state) => state.global.menuOpened) ? s.menuOpened : '';
	const planMan = useSelector((state) => state.global.planMan);
	const stepsComponentsType = planMan ? stepsComponentsMan : stepsComponents;
	const questionsType = planMan ? questionsMan : questions;
	const stepName = useSelector((state) => state.steps.currentStep);
	const xmasBgHandler = stepName === 'xmas_start_screen' && s.xmas_start_screen_bg;
	const bigPhotoBgHandler = stepName === 'big_photo_start_screen' && s.big_photo_start_screen_bg;
	const newYearBgHandler = stepName === 'new_year_start_screen' && s.new_year_start_screen_bg;
	const stepsWithoutStatusBar = [
		'xmas_start_screen', 
		'new_year_start_screen', 
		'big_photo_start_screen', 
		'age_group_start_screen',
		'zones_start_screen',
	];
	const stepsWithoutActionBar = ['choose_days'];
	stepsWithoutActionBar.includes(stepName) ? showActionBar = true : null;
	stepsWithoutStatusBar.includes(stepName) ? showStatusBar = false : showStatusBar = true;

	return (
		<div className={s.page}>
			<div className={
				classNames(showStatusBar ? s.contentWrapper : s.contentWrapper_full,
					xmasBgHandler,
					newYearBgHandler,
					bigPhotoBgHandler
				)
			}>
				<div className={classNames(s.header, menuOpenedClass)}>
					<div className="debug" />
					{showStatusBar &&
						<div className={s.topContent}>
							<HeaderButton showMenuButton={showMenuButton} planMan={planMan} />
							<ProgressBar planMan={planMan} />
						</div>
					}
				</div>
				<StepsContent stepsComponentsType={stepsComponentsType} />
				<ActionBar
					show={showActionBar}
					currentStepCompleted={currentStepCompleted}
					questionsType={questionsType}
					totalSteps={totalSteps}
					planMan={planMan}
					stepName={stepName}
				/>
			</div>
		</div>
	);
}

export default Steps;
